import { updateDataInArray } from '../../utils/function.utils'
import FeedbackTypes from './feedback.types'

const INITIAL_STATE = {
	data: null,
	total: 0,
	page: 1,
	selectedFeedback: null,
}

const FeedbackReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case FeedbackTypes.GET_FEEDBACKS:
			return {
				...state,
				...payload,
			}
		case FeedbackTypes.UPDATE_FEEDBACKS:
			return {
				...state,
				data: updateDataInArray(state.data, payload),
			}
		case FeedbackTypes.SELECT_FEEDBACKS:
			return {
				...state,
				selectedFeedback: payload,
			}
		case FeedbackTypes.ADD_REPLY:
			return {
				...state,
				selectedFeedback: {
					...state.selectedFeedback,
					replies: [...state.selectedFeedback.replies, payload],
				},
				data: state.data.map(feedback => {
					if (feedback.id === payload.feedbackID) {
						feedback.replies = [...feedback.replies, payload]
					}
					return feedback
				}),
			}
		default:
			return state
	}
}

export default FeedbackReducer
